<!-- Combined Header and Navigation Component -->
@if (showNavigation()) {
  <div
    class="sticky top-[-1px] z-50 mb-4 transition-all duration-300 ease-in-out rounded-b-2xl shadow-lg overflow-hidden border border-t-0 border-gray-200/50 backdrop-blur-xs bg-white/80"
  >
  <!-- Page Header Section -->
  @if (showPageHeader()) {
    <div class="flex items-center justify-between px-4 pt-3 mb-3">
      @if (showStartseiteLink()) {
        <a
          class="flex items-center gap-2 text-sm text-secondary-text"
          routerLink="/home"
        >
          <lucide-angular [img]="chevronLeft" size="24"></lucide-angular>
          <span class="font-semibold">Startseite</span>
        </a>
      }
      <h1 class="text-sm font-semibold text-secondary-text truncate pr-4 ml-4">{{ pageTitle() }}</h1>
    </div>
  }

  <!-- Desktop Navigation -->
  <div class="max-sm:hidden justify-center">
    <nav class="inline-flex w-full px-4 py-2 gap-1 justify-center">
      @for (item of homeNavItems; track item.path) {
        <a
          [routerLink]="['/', item.path]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [title]="item.label"
          [class]="
            isActive(item.path)
              ? 'px-5 py-3 rounded-full text-sm font-medium bg-gradient-to-r from-[rgb(197,164,223)] to-[rgb(235,100,100)] text-white shadow-md will-change-transform transition-transform duration-200 ease-out scale-105 flex flex-col items-center gap-1'
              : 'px-5 py-3 rounded-full text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:scale-105 will-change-transform transition-transform duration-200 ease-out flex flex-col items-center gap-1'
          "
        >
          {{ item.label }}
        </a>
      }
      @if (homeNavItems.length > 0 && eventNavItems().length > 1) {
        <div class="flex items-center" aria-hidden="true">
          <div class="h-6 w-px bg-gray-400/50 mx-2"></div>
        </div>
      }
      @if (eventNavItems().length > 1) {
        @for (item of eventNavItems(); track item.path) {
          <a
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [title]="item.label"
            [routerLink]="['/event', item.path, eventType(), eventDocumentId()]"
            [class]="
              isActive(item.path)
                ? 'px-5 py-3 rounded-full text-sm font-medium bg-gradient-to-r from-[rgb(197,164,223)] to-[rgb(235,100,100)] text-white shadow-md will-change-transform transition-transform duration-200 ease-out scale-105 flex flex-col items-center gap-1'
                : 'px-5 py-3 rounded-full text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:scale-105 will-change-transform transition-transform duration-200 ease-out flex flex-col items-center gap-1'
            "
          >
            {{ item.label }}
          </a>
        }
      }
    </nav>
  </div>

  <!-- Mobile Navigation -->
  <div class="sm:hidden">
    <div class="relative">
      <!-- Left Fade Gradient -->
      @if (hasNavigationItems() && showLeftChevron) {
        <div class="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white/30 via-white/20 via-white/10 to-transparent pointer-events-none z-10"></div>
      }

      <!-- Right Fade Gradient -->
      @if (hasNavigationItems() && showRightChevron) {
        <div class="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white/30 via-white/20 via-white/10 to-transparent pointer-events-none z-10"></div>
      }

      <!-- Left Chevron -->
      @if (hasNavigationItems() && showLeftChevron) {
        <button
          (click)="scrollLeft()"
          class="absolute left-3 top-1/2 -translate-y-1/2 z-20 p-2 bg-white/90 hover:bg-white rounded-full shadow-md transition-all duration-200"
          aria-label="Scroll left"
        >
          <lucide-angular [img]="chevronLeft" size="16" class="text-gray-600"></lucide-angular>
        </button>
      }

      <!-- Right Chevron -->
      @if (hasNavigationItems() && showRightChevron) {
        <button
          (click)="scrollRight()"
          class="absolute right-3 top-1/2 -translate-y-1/2 z-20 p-2 bg-white/90 hover:bg-white rounded-full shadow-md transition-all duration-200"
          aria-label="Scroll right"
        >
          <lucide-angular [img]="chevronRight" size="16" class="text-gray-600"></lucide-angular>
        </button>
      }

      <!-- Scrollable Navigation Container -->
      @if (hasNavigationItems()) {
        <div
          #mobileScrollContainer
          class="flex overflow-x-auto scrollbar-hide p-4 gap-2 scroll-smooth"
          (scroll)="onScroll()"
        >
          @for (item of homeNavItems; track item.path) {
            <a
              [routerLink]="['/', item.path]"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [title]="item.label"
              [class]="
                isActive(item.path)
                  ? 'px-5 py-3 rounded-full text-sm font-medium bg-gradient-to-r from-[rgb(197,164,223)] to-[rgb(235,100,100)] text-white shadow-md whitespace-nowrap flex-shrink-0'
                  : 'px-5 py-3 rounded-full text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 whitespace-nowrap flex-shrink-0'
              "
            >
              {{ item.label }}
            </a>
          }
          @if (homeNavItems.length > 0 && eventNavItems().length > 1) {
            <div class="flex items-center" aria-hidden="true">
              <div class="h-6 w-px bg-gray-400/50 mx-2 flex-shrink-0"></div>
            </div>
          }
          @if (eventNavItems().length > 1) {
            @for (item of eventNavItems(); track item.path) {
              <a
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [title]="item.label"
                [routerLink]="['/event', item.path, eventType(), eventDocumentId()]"
                [class]="
                  isActive(item.path)
                    ? 'px-5 py-3 rounded-full text-sm font-medium bg-gradient-to-r from-[rgb(197,164,223)] to-[rgb(235,100,100)] text-white shadow-md whitespace-nowrap flex-shrink-0'
                    : 'px-5 py-3 rounded-full text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 whitespace-nowrap flex-shrink-0'
                "
              >
                {{ item.label }}
              </a>
            }
          }
        </div>
      }
    </div>
  </div>
  </div>
}
